/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const UserFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M7.0099 6.9901C7.0099 4.23414 9.24404 2 12 2C14.756 2 16.9901 4.23414 16.9901 6.9901C16.9901 9.74605 14.756 11.9802 12 11.9802C9.24404 11.9802 7.0099 9.74605 7.0099 6.9901ZM6.62186 13.902C8.4103 13.1856 10.5392 12.8267 12 12.8267C13.4608 12.8267 15.5897 13.1856 17.3781 13.902C18.2731 14.2606 19.1445 14.7328 19.8079 15.345C20.4779 15.9634 21 16.7902 21 17.8168V18.8193C21 19.9143 20.1123 20.802 19.0173 20.802H4.98267C3.88767 20.802 3 19.9143 3 18.8193V17.8168C3 16.7902 3.52208 15.9634 4.1921 15.345C4.85546 14.7328 5.72685 14.2606 6.62186 13.902Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </Icon>
  );
});

export { UserFillIcon };
